"use client";

import {JSX} from "react";

import Image from "next/image";

import {type SpaceProps, useSectionSpace} from "@/sections/use-section-space";

import {Typography} from "@/shared/ui/data-display/typography";
import {ContainerBase} from "@/shared/ui/layout/container-base";

import {CardItem} from "./info-cards-section-card";

import "./info-cards-section.scss";

export interface InfoCardItem {
    title: string;
    text: string;
}

export interface InfoCardsSectionData {
    sectionTitle: string;
    image: string;
    arrow: boolean;
    items: Array<InfoCardItem>;
    space?: SpaceProps;
    anchorId?: string;
}

export function InfoCardsSection(props: InfoCardsSectionData): JSX.Element | null {
    const sectionVars = useSectionSpace(props.space);
    const {sectionTitle, image, items} = props;

    return (
        <section className="info-cards-section" style={sectionVars}>
            <ContainerBase>
                <div className="info-cards-section__header">
                    <Image src={image} alt={sectionTitle} width={40} height={40} />
                    <Typography as="h2" size={{desktop: 20, mobile: 18}} weight={600}>
                        {sectionTitle}
                    </Typography>
                </div>

                <div className="info-cards-section__grid">
                    {items.map((item, index) => (
                        <CardItem key={index} title={item.title} text={item.text} />
                    ))}
                </div>
            </ContainerBase>
        </section>
    );
}
